import React from 'react';
import cn from 'classnames';
import inlineIcons from './inline';
import * as styles from './Icon.module.scss';

export default function Icon({ name, className, ...props }) {
  if (!name) {
    return null;
  }

  const iconClass = cn(className, styles.icon);

  // if you need to style specific elements inside svgs, use inlineIcons
  const InlineIcon = inlineIcons[name];

  if (InlineIcon) {
    return <InlineIcon className={iconClass} {...props} />;
  }

  return <img src={`/assets/icons/${name}.svg`} className={iconClass} alt="" {...props} />;
}
